import { axiosInstance } from "../axiosInstance";

const getImportUsersList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`_agency/import_users`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const getUsersList = ({ page,
    per_page = 1,
    delay = 1,
    search }) => axiosInstance.get(`_agency/users`, {
        params: {
            page,
            per_page,
            delay,
            search
        }
    }).then(res => res?.data)

const importUsers = (data) => axiosInstance.post(`_agency/import_users/create`, data, {
    headers: {
        "Content-Type": "multipart/form-data"
    }
})
const removeAgencyCode = (data) => axiosInstance.post(`_agency/user/remove-code`, data)
const removeUserAgency = (data) => axiosInstance.post(`_agency/user/remove-agency`, data)
export { getImportUsersList, importUsers, getUsersList, removeAgencyCode, removeUserAgency }
